import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { UserRole } from '../types/User';
import { Paper, Typography, Box } from '@mui/material';

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: UserRole[];
}

const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({ children, allowedRoles }) => {
  const { user, isAuthenticated, hasPermission } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!hasPermission(allowedRoles)) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '70vh' }}>
        <Paper elevation={3} sx={{ p: 4, maxWidth: 400, textAlign: 'center' }}>
          <Typography variant="h5" color="error" gutterBottom>
            접근 권한 없음
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            이 페이지에 접근할 권한이 없습니다.
          </Typography>
          <Typography variant="body2" color="textSecondary">
            현재 권한: {user?.role ? {
              [UserRole.SYSTEM_ADMIN]: '시스템 관리자',
              [UserRole.GENERAL_ADMIN]: '일반 관리자',
              [UserRole.GENERAL_USER]: '일반 사용자'
            }[user.role] : '알 수 없음'}
          </Typography>
        </Paper>
      </Box>
    );
  }

  return <>{children}</>;
};

export default RoleProtectedRoute;